import {createRoot} from 'react-dom/client'
import {Chart, registerables} from 'chart.js'
import {QueryClient, QueryClientProvider} from 'react-query'
import {ReactQueryDevtools} from 'react-query/devtools'
// Apps
import {MetronicI18nProvider} from './template/_metronic/i18n/Metronici18n'
import './template/_metronic/assets/sass/style.react.scss'
import './template/_metronic/assets/fonticon/fonticon.css'
import './template/_metronic/assets/keenicons/duotone/style.css'
import './template/_metronic/assets/keenicons/outline/style.css'
import './template/_metronic/assets/keenicons/solid/style.css'
/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './template/_metronic/assets/css/style.rtl.css'
 **/
import './template/_metronic/assets/sass/style.scss'
import {AppRoutes} from './app/routing/AppRoutes'
import {Provider} from 'react-redux'
import {store} from './redux/store'
/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
Chart.register(...registerables)

const queryClient = new QueryClient()
const container = document.getElementById('root')
if (container) {
  createRoot(container).render(
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <MetronicI18nProvider>
          <AppRoutes />
        </MetronicI18nProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </Provider>
  )
}
